import React from 'react';
import { Container, Segment, Image, Header } from 'semantic-ui-react';

import SlackButton from '../components/SlackButton';
import GoogleButton from '../components/GoogleButton';

import icon from '../images/icon.svg';
import '../styles/Login.css';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.handleSignInWithGoogle = this.handleSignInWithGoogle.bind(this);
    this.handleSignInWithSlack = this.handleSignInWithSlack.bind(this);
  }

  handleSignInWithGoogle() {
    window.location.href = process.env.REACT_APP_AUTH_GOOGLE_URL;
  }

  handleSignInWithSlack() {
    window.location.href = process.env.REACT_APP_AUTH_SLACK_URL;
  }

  render() {
    return (
      <Container className="Login">
        <Segment basic textAlign="center">
          <Image centered src={icon} alt="Teampicture logo" size="mini" />
          <Header as="h2">Welcome to Teampicture</Header>
        </Segment>
        <Segment basic textAlign="center">
          <GoogleButton onSignIn={this.handleSignInWithGoogle} />
          <SlackButton onSignIn={this.handleSignInWithSlack} />
        </Segment>
      </Container>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js